import { LogGroup , Log ,MyPIXIContainer } from "./MyHelpers";
import { CashInParams , CashOutParams } from "./slot/SlotGame";
import { Money } from "./Money";
import { BackendSettings } from "./help/Help";

export interface BalanceChangeParams
{
	newBalance: number;
	oldBalance: number;
}

export type OnBalanceChangedHandler = (balanceParams: BalanceChangeParams) => void;
export type OnCashInHandler = (cashInParams: CashInParams) => void;
export type OnCashOutHandler = (cashOutParams: CashOutParams) => void;


interface GameStartData
{
	started: boolean;
	balanceBefore: number;
	bet: number;
}

export class ClientState
{
	// balance in cents
	private balance: number = 0;

	// win in cents
	private previousWin: number = 0;
	private win: number = 0;

	protected logGroup: LogGroup = new LogGroup("ClientState");

	constructor()
	{
	}


	public get Win(): number
	{
		return this.win;
	}

	public get PreviousWin(): number
	{
		return this.previousWin;
	}

	public SetWin(win: number, reason: string)
	{
		this.previousWin = this.win;
		this.win = win;
		// Log.Debug(this.logGroup, `SetWin() before: ${this.previousWin }, after: ${this.win}`);

		if (this.previousWin > this.win)
		{
			Log.Error(this.logGroup, "Win set to lower value?");
		}
		reason = null
	}

	public ResetNewGame(): void
	{
		// Log.Debug(this.logGroup, "ResetNewGame()");
		// Log.Debug(this.logGroup, `SetWin() before: ${this.win}, after: 0`);
		this.win = 0;
	}


	public Balance(): number{
		return this.balance;
	}

	public Locale(): string {
		return "en-US";
	}

	// TODO use some settings
	public Currency(): string {
		return "MXN";
	}

	/**
	 * Used for backend to update state. Ideally there should not be difference with current balance and new balance
	 * @param balance 
	 */
	public UpdateBalance(newBalance: number): void {
		let oldBalance: number = this.balance;
		this.balance = newBalance;

		// Log.Debug(this.logGroup, "UpdateBalance(" + JSON.stringify({newBalance: newBalance, oldBalance: oldBalance}) + ")");

		if (oldBalance != newBalance)
		{
			this.OnBalanceChange({
				newBalance: newBalance,
				oldBalance: oldBalance
			});
		}
	}

	protected gameStartData: GameStartData = {
		started: false,
		balanceBefore: 0,
		bet: 0
	};

	public TryGameStart(totalBet: Money): boolean
	{
		if (this.gameStartData?.started)
		{
			Log.Error(this.logGroup, "Game already started or previous game not ended");
			return false;
		}

		if (this.balance < totalBet.InCents)
		{
			Log.Error(this.logGroup, "Not enough credit");
			return false;
		}

		this.gameStartData = {
			started: true,
			balanceBefore: this.balance,
			bet: totalBet.InCents,
		};

		if (this.freeRoundsAvailable)
		{
			Log.Debug(this.logGroup, "TryGameStart() free rounds available");

			this.gameStartData = {
				started: true,
				balanceBefore: this.balance,
				bet: 0,
			};
		}

		this.UpdateBalance(this.balance - this.gameStartData.bet);
		return true;
	}

	public ConfirmGameStart(balanceBefore: Money, totalBet: Money): boolean
	{
		if (!this.gameStartData?.started)
		{
			Log.Error(this.logGroup, "Game not started");
			return false;
		}

		let needsUpdating: boolean = false;

		if (this.gameStartData.balanceBefore != balanceBefore.InCents)
		{
			this.gameStartData = {
				...this.gameStartData,
				balanceBefore: balanceBefore.InCents
			};

			needsUpdating = true;
		}

		if (this.gameStartData.bet != totalBet.InCents)
		{
			this.gameStartData = {
				...this.gameStartData,
				bet: totalBet.InCents
			};

			needsUpdating = true;
		}

		if (this.freeRoundsAvailable)
		{
			this.gameStartData = {
				...this.gameStartData,
				bet: 0,
			};

			needsUpdating = true;
		}

		if (needsUpdating)
		{
			this.UpdateBalance(this.gameStartData.balanceBefore - this.gameStartData.bet);
		}

		return true;
	}

	public CancelGame(): boolean
	{
		if (!this.gameStartData?.started)
		{
			Log.Error(this.logGroup, "Game not started");
			return false;
		}

		this.UpdateBalance(this.gameStartData.balanceBefore);

		this.gameStartData = {
			started: false,
			balanceBefore: 0,
			bet: 0,
		}

		return true;
	}



	// public GameStart(totalBet: Money): void {

	// 	if (this.gameStarted)
	// 	{
	// 		throw "Game already started or previous game not ended";
	// 	}

	// 	this.gameStarted = true;

	// 	if (this.balance >= totalBet.InCents) {
	// 		// Log.Debug(this.logGroup, "GameStart(balance=" + this.balance + ", totalBet=" + totalBet.InCents + ")");
	// 		//this.balance -= totalBet;
	// 		this.UpdateBalance(this.balance - totalBet.InCents);
	// 	}
	// 	else
	// 	{
	// 		throw new Error("Can place this bet, balance to low");
	// 	}
	// }

	// public GameStartRefresh(totalBet: Money): void {

	// 	this.gameStarted = true;
	// 	this.UpdateBalance(this.balance - totalBet.InCents);

	// 	if (this.balance >= totalBet.InCents) {
	// 		// Log.Debug(this.logGroup, "GameStart(balance=" + this.balance + ", totalBet=" + totalBet.InCents + ")");
	// 		//this.balance -= totalBet;
			
	// 	}
	// 	else
	// 	{
	// 		throw new Error("Can place this bet, balance to low");
	// 	}
	// }

	/**
	 * 
	 * @param totalWin 
	 */
	public GameEnd(totalWin: number, currentBalance: number): boolean
    {

		if (!this.gameStartData?.started)
		{
			// Benign when GameFinished is entered twice (stale collect / autoplay race)
			Log.Debug(this.logGroup, "GameEnd skipped — game not started");
			return false;
		}

		let expectedBalance = this.balance + totalWin;

		// if (this.freeRoundsAvailable)
		// {
		// 	Log.Debug(this.logGroup, "GameEnd() free rounds available");
		// 	this.UpdateBalance(this.balance + totalWin);
		// 	return true;
		// }
		

		//this.balance += totalWin;
		// Log.Debug(this.logGroup, "GameEnd(balance=" + this.balance + ", totalWin=" + totalWin + ")");

		
		if (expectedBalance != currentBalance)
		{
			// expected balance and actual balance don't match
			debugger;
		}

		this.UpdateBalance(currentBalance);

		this.gameStartData = {
			started: false,
			balanceBefore: 0,
			bet: 0,
		}
		return true;
	}

	/**
	 * Called when balance has been changed by backend
	 */
	protected freeRoundsAvailable: boolean = false;
	public CheckFreeRounds(freeRoundsAvailable: boolean)
	{
		this.freeRoundsAvailable =  freeRoundsAvailable;

	}
	protected balanceChangedCallback: OnBalanceChangedHandler[] = [];
	protected OnBalanceChange(balanceChangeParams: BalanceChangeParams): void {

		for (let i = 0; i < this.balanceChangedCallback.length; i++)
		{
			this.balanceChangedCallback[i](balanceChangeParams);
		}
	}

	public AddOnBalanceChangedCallback(callback: OnBalanceChangedHandler)
	{
		if (this.balanceChangedCallback.find(cb => cb == callback))
		{
			// already added
			return;
		}

		
		this.balanceChangedCallback.push(callback);
	}

	public RemoveBalanceChangedCallback(callback: OnBalanceChangedHandler)
	{
		this.balanceChangedCallback = this.balanceChangedCallback.filter(cb => cb != callback);
	}

	/**
	 * 
	 */
	protected cashInCallbacks: OnCashInHandler[] = [];
	public OnCashIn(callback: OnCashInHandler)
	{
		this.cashInCallbacks.push(callback);
	}

	public RemoveOnCashIn(callback: OnCashInHandler)
	{
		this.cashInCallbacks = this.cashInCallbacks.filter(cb => cb != callback);
	}

	public CashIn(cashInParams: CashInParams) {
		// Log.Debug(this.logGroup, "CashIn(" + JSON.stringify(cashInParams) + ")");

		this.UpdateBalance(cashInParams.Current.InCents);

		for (let i = 0; i < this.cashInCallbacks.length; i++) {
			this.cashInCallbacks[i](cashInParams);
		}
	}

	/**
	 * 
	 */
	protected cashOutCallbacks: OnCashOutHandler[] = [];

	public OnCashOut(callback: OnCashOutHandler)
	{
		this.cashOutCallbacks.push(callback);
	}

	public RemoveOnCashOut(callback: OnCashOutHandler)
	{
		this.cashOutCallbacks = this.cashOutCallbacks.filter(cb => cb != callback);
	}

	public CashOut(cashOutParams: CashOutParams) {
		// Log.Debug(this.logGroup, "CashOut(" + JSON.stringify(cashOutParams) + ")");

		this.UpdateBalance(cashOutParams.Current.InCents);

		for (let i = 0; i < this.cashOutCallbacks.length; i++) {
			this.cashOutCallbacks[i](cashOutParams);
		}
	}
}